import { render } from "./UploadData.view.vue?vue&type=template&id=fb8fba66&scoped=true&ts=true"
import script from "./UploadData.view.vue?vue&type=script&lang=ts"
export * from "./UploadData.view.vue?vue&type=script&lang=ts"

import "./UploadData.view.vue?vue&type=style&index=0&id=fb8fba66&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb8fba66"]])

export default __exports__